/* eslint-disable @typescript-eslint/no-explicit-any */
import { DefaultValue } from 'recoil';

function unStringfy(str: any) {
  try {
    return JSON.parse(str);
  } catch (e) {
    console.error('[atom-effects] unStringfy failed:', e);
    return str;
  }
}

export const localPersistEffect = ({ onSet, setSelf, node }: any) => {
  const key = node.key;
  try {
    const storedItems = localStorage.getItem(key);
    if (storedItems != null) {
      const parsed = unStringfy(storedItems);
      console.log(`[localPersistEffect] 🔄 Restored "${key}" from localStorage:`, parsed);
      setSelf(parsed);
    } else {
      console.log(`[localPersistEffect] 📭 No stored value for "${key}"`);
    }
  } catch (error) {
    console.error(`[localPersistEffect] ❌ Error reading "${key}":`, error);
  }

  onSet((newItems: any) => {
    try {
      if (newItems instanceof DefaultValue) {
        console.log(`[localPersistEffect] 🗑️ Removing "${key}" (DefaultValue)`);
        localStorage.removeItem(key);
      } else {
        console.log(`[localPersistEffect] 💾 Persisting "${key}":`, newItems);
        localStorage.setItem(key, JSON.stringify(newItems));
      }
    } catch (error) {
      if ((error as Error).name === 'QuotaExceededError') {
        console.error(`[localPersistEffect] ⚠️ QuotaExceeded for "${key}"`);
      } else {
        console.error(`[localPersistEffect] ❌ Error saving "${key}":`, error);
      }
    }
  });
};
